<ng-container *ngIf="!notDisplayNav">
  <ng-container *ngIf="isHomePage">
    <div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
      <!-- NAV BAR -->
      <div class="container">
        <div class="mobile-nav-bar-home d-flex justify-content-between">
          <a class="nav-item fw-bold brand p-1 ps-0" [routerLink]="['/']" routerLinkActive="router-link-active">
            <img class="home-logo" src="assets/images/home-logo.png" draggable="false" />
          </a>
          <div class="right-nav-menu d-flex flex-row gap-3">
            <div class="notification-button-wrapper">
              <fgb-notification-button [size]="24" />
            </div>
            <button class="nav-item fw-bold navbar-toggler m-0 px-2" (click)="isCollapsed = !isCollapsed">
              <span class="icon material-icons font-size"> menu </span>
            </button>
          </div>
        </div>
      </div>

      <!-- NAV SCREEN -->
      <ng-container *ngIf="isCollapsed">
        <div class="mobile-nav-menu-dropdown">
          <div class="container">
            <div class="d-flex flex-column mobile-nav-menu-content">
              <!-- Close Button -->
              <button class="close-button position-absolute border-0" (click)="isCollapsed = !isCollapsed">
                <i class="material-icons close-btn text-white">close</i>
              </button>

              <!-- Club Logo -->
              <div class="d-flex align-items-center justify-content-start p-1 ps-0 brand-logo">
                <img class="brand" src="assets/images/home-logo.png" draggable="false" />
              </div>

              <div class="modal-content d-flex gap-2">
                <div class="modal-header w-100 d-flex align-items-center justify-content-between mt-3">
                  <div class="header-left">
                    <div
                      class="card-name text-white text-uppercase font-size-14 font-page-heading"
                      *ngIf="memberDetails$ | async as memberDetails"
                    >
                      {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
                    </div>
                    <div class="account-num-header text-white" *ngIf="card$ | async as memberCard">
                      <span class="font-size-12">{{ 'barcode.memberid' | translate }} </span>
                      <span class="font-size-12">{{ memberCard.ExternalRefNumber }}</span>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-2 mt-2 w-100">
                  <div class="d-flex mb-1 points-container w-100 justify-content-between">
                    <div class="points-item" *ngIf="pointsBalance$">
                      <span class="icons material-icons" aria-hidden="true">loyalty</span>
                      <div class="points-balance">
                        <div class="text-number font-size-18 font-page-heading">
                          {{ pointsBalance$ | async }}
                        </div>
                        <div class="text-unit font-size-12">{{ 'member.card.points.label' | translate }}</div>
                      </div>
                    </div>
                    <div class="points-item" *ngIf="ecashBalance$">
                      <span class="icons material-symbols-outlined"> money_bag </span>
                      <div class="e-cash-section">
                        <div class="text-number font-size-18 font-page-heading">
                          {{ ecashBalance$ | async | FortressCurrencyPipe }}
                        </div>
                        <div class="text-unit font-size-12">{{ 'member.card.ecash.label' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="add-card mb-3 mt-2">
                <fgb-add-card-payment />
              </div>

              <div class="mobile-nav-button-container">
                <!-- Nav Buttons -->
                <a
                  class="nav-item"
                  [routerLink]="['/']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.home' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/account']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.account' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/rewards']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.rewards' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/challenges']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.challenges' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/ecash']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.ecash' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/rewards/wallet']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.wallet' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/earn']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.earn' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/worksheet']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.activity' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/faq']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.faq' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/contact']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a
                  class="nav-item"
                  [routerLink]="['/terms']"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <div class="content">
                    <div class="nav-text">{{ 'nav.terms' | translate }}</div>
                  </div>

                  <span class="material-icons"> chevron_right </span>
                </a>

                <a class="nav-item" (click)="logout()">
                  <div class="content">
                    <div class="nav-text">{{ 'nav.log.out' | translate }}</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="isWallet || isTertiary">
    <div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
      <div
        class="container"
        [ngClass]="isWallet && 'pt-1'"
        [ngClass]="(isWalletItem || isClaimedPage || isCampaignPage || isTertiary || isCheckOut) && 'pb-5'"
      >
        <div class="mobile-nav-bar p-relative d-flex justify-content-start align-items-center w-100">
          <a *ngIf="isRootRoute(); else useRouterLink" href="/"
            ><span class="material-symbols-outlined text-white d-flex align-items-center"> arrow_back_ios </span></a
          >
          <ng-template #useRouterLink>
            <a [routerLink]="getDynamicRoute()"
              ><span class="material-symbols-outlined text-white d-flex align-items-center"> arrow_back_ios </span></a
            >
          </ng-template>

          <div class="reward-tertiary-title font-page-heading font-size-18 text-uppercase text-white">{{ title }}</div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isWallet && !isTertiary && !isHomePage">
    <div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
      <div class="container">
        <div class="mobile-nav-bar mobile-nav-point p-relative d-flex justify-content-between align-items-center w-100 pb-5">
          <div class="left-bar d-flex flex-row gap-2">
            <a [href]="isPurchaseSuccessPage ? '/rewards' : ''"
              ><span class="material-symbols-outlined text-white d-flex align-items-center"> arrow_back_ios </span></a
            >

            <div class="title font-page-heading font-size-20 text-uppercase text-white">{{ title }}</div>
          </div>

          <div class="right-bar d-flex flex-row gap-2">
            <div class="right-bar-item" *ngIf="pointsBalance$">
              <span class="icons material-icons font-size-18" aria-hidden="true">loyalty</span>
              <div class="font-size-14 point-value">
                {{ pointsBalance$ | async }}
              </div>
            </div>

            <div class="right-bar-item p-2" routerLink="/rewards/wallet">
              <span class="icons material-symbols-outlined"> qr_code_2 </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
